/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxGpsTrackingTabAction,
    CashBoxGpsTrackingTabActionType,
    fetchCashboxLocationDataSuccessAction,
    fetchCashboxLocationDataErrorAction,
    fetchCashboxHistoryLocationsPageSuccessAction,
    fetchCashboxHistoryLocationsPageErrorAction,
    fetchGpsTrackingListSuccessAction,
    fetchGpsTrackingListErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxGpsTrackingTabActions';
import { parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const getCashBoxLocationDataEpic: Epic<CashBoxGpsTrackingTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxGpsTrackingTabActionType.OPEN_GPS_TRACKING_TAB),
        switchMap(() => {
            const { CashboxTaxNumber } = state$.value.routerState.route.params;

            return from(cashboxesClient.getCashBoxLocationData(CashboxTaxNumber)).pipe(
                map((resp) => {
                    return fetchCashboxLocationDataSuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashboxLocationDataErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.cashboxLocationDataNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(CashBoxGpsTrackingTabActionType.EXIT_GPS_TRACKING_TAB)),
            );
        }),
    );
};

export const getHistoryLocationsPageEpic: Epic<CashBoxGpsTrackingTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(
            CashBoxGpsTrackingTabActionType.OPEN_GPS_TRACKING_TAB,
            CashBoxGpsTrackingTabActionType.FETCH_HISTORY_LOCATIONS_NEXT_PAGE_START,
            CashBoxGpsTrackingTabActionType.APPLY_HISTORY_LOCATIONS_FILTERING,
        ),
        switchMap(() => {
            const cashboxTaxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const queryParams = { ...state$.value.cashBoxGpsTrackingTabReducer.historyLocationsQueryParams };

            return from(cashboxesClient.getHistoryLocationsList(cashboxTaxNumber, queryParams)).pipe(
                map((resp) => {
                    return fetchCashboxHistoryLocationsPageSuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashboxHistoryLocationsPageErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.getCashboxLocationsHistoryFailed')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(CashBoxGpsTrackingTabActionType.EXIT_GPS_TRACKING_TAB)),
            );
        }),
    );
};

export const getGpsTrackingListEpic: Epic<CashBoxGpsTrackingTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxGpsTrackingTabActionType.FETCH_CAHSBOX_GPS_TRACKING_START),
        switchMap(() => {
            const cashboxTaxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const queryParams = {
                fromInsertedDateAtUtc:
                    state$.value.cashBoxGpsTrackingTabReducer.historyLocationsQueryParams.fromInsertedDateAtUtc,
                toInsertedDateAtUtc:
                    state$.value.cashBoxGpsTrackingTabReducer.historyLocationsQueryParams.toInsertedDateAtUtc,
            };
            return from(cashboxesClient.getGpsTrackingList(cashboxTaxNumber, queryParams)).pipe(
                map((resp) => {
                    return fetchGpsTrackingListSuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchGpsTrackingListErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.getCashboxTrackingDataFailed')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(CashBoxGpsTrackingTabActionType.EXIT_GPS_TRACKING_TAB)),
            );
        }),
    );
};
